import { createRouter, createWebHistory } from 'vue-router'
import WelcomeMore from '@/views/dashboard/WelcomeMore.vue'
import ShopStatistics from '@/views/dashboard/ShopStatistics.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: { name: 'login' } // 🎯 修复：使用命名路由
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      beforeEnter: (to, from, next) => {
        console.log('登录页路由守卫，检查token:', window.localStorage.getItem("token"));
        if (window.localStorage.getItem("token")) {
          next({ name: 'home' }); // 🎯 修复：使用命名路由
        } else {
          next();
        }
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/HomePage.vue'),
      beforeEnter: (to, from, next) => {
        console.log('首页路由守卫，检查token:', window.localStorage.getItem("token"));
        if (!window.localStorage.getItem("token")) {
          next({ name: 'login' }); // 🎯 修复：使用命名路由
        } else {
          next();
        }
      },
      children: [
        {
          path: 'welcome/welcome',
          name: 'welcome',
          component: () => import('../components/welcome/welcome/index.vue'),
          meta: { title: '数据统计' }
        },
        {
          path: '/welcome-more',
          name: 'WelcomeMore',
          component: WelcomeMore,
          meta: {
            title: '订单来源详情',
            requiresAuth: true // 如果需要认证
          }
        },
        {
          path: '/shop-statistics',
          name: 'ShopStatistics',
          component: ShopStatistics,
          meta: {
            title: '店铺数据统计',
            requiresAuth: true
          }
        },
        {
          path: 'person',
          name: 'person',
          component: () => import('../components/person/index.vue')
        },
        {
          path: 'order',
          name: 'order',
          component: () => import('../components/order/OrderList.vue')
        },
        {
          path: 'amount',
          name: 'amount',
          component: () =>import('../components/money/amount/index.vue')
        },
        {
          path: 'moneyLog',
          name: 'moneyLog',
          component: () =>import('../components/money/MoneyList.vue')
        },
        {
          path: 'packageLog',
          name: 'packageLog',
          component: () =>import('../components/order/ShopPackageList.vue')
        },
        {
          path: 'detail',
          name: 'detail',
          component: () => import('../components/order/orderDetail/OrderDetail.vue')
        },
        {
          path: 'shop/shopAuthentication',
          name: 'shopAuthentication',
          component: () => import('../components/shop/shopAuthentication/index.vue')
        },
        {
          path: 'shop/shop',
          name: 'shop',
          component: () => import('../components/shop/shop/index.vue')
        },
        {
          path: 'shop/shopEvaluation',
          name: 'shopEvaluation',
          component: () => import('../components/shop/shopEvaluation/index.vue')
        },
        {
          path: 'shop/shopPackage',
          name: 'shopPackage',
          component: () => import('../components/shop/shopPackage/index.vue')
        },
        {
          path: 'order/shopFinanceEvaluationOrders',
          name: 'shopFinanceEvaluationOrders',
          component: () => import('../components/order/shopFinanceEvaluationOrders/index.vue')
        },
        {
          path: 'order/shopFinancePackageOrders',
          name: 'shopFinancePackageOrders',
          component: () => import('../components/order/shopFinancePackageOrders/index.vue')
        },
        {
          path: 'appeal',
          name: 'appeal',
          component: () =>import('../components/appeal/appeal.vue')
        },
        {
          path: 'userAppeal',
          name: 'userAppeal',
          component: () =>import('../components/userAppeal/userAppeal.vue')
        },
        {
          path: 'shopEvaluationReport',
          name: 'shopEvaluationReport',
          component: () =>import('../components/shopEvaluationReport/shopEvaluationReport.vue')
        },
        {
          path: 'shop/shopEvaluationReview',
          name: 'shopEvaluationReview',
          component: () => import('../components/shop/shopEvaluationReview/index.vue')
        },
        {
          path: 'shop/shopEvaluationDetail',
          name: 'shopEvaluationDetail',
          component: () => import('../components/shop/shopEvaluationDetail/index.vue')
        },
        {
          path: 'order/zmmyAgreement',
          name: 'zmmyAgreement',
          component: () => import('../components/order/zmmyAgreement/index.vue')
        },
      ]
    }
  ]
})

export default router
